export const FIRST_AXES_VIEW = 'first-axes-view';
export const SECOND_AXES_VIEW = 'second-axes-view';
/** 对称条形图的分组 key 值 */
export const SERIES_FIELD_KEY = 'series-field-key';
